function importAll(r) {
  return r.keys().map((key) => ({
    title: key.replace("./", "").replace(/\.[^/.]+$/, ""),
    src: r(key),
  }));
}

// Importe toutes les images du dossier
const images = importAll(
  require.context("../../assets/images/resto", false, /\.(jpg|jpeg|png|gif)$/)
);

export default images;
